import { KioskType } from 'types/KioskTypes';

import SHAREBOX_KIOSK_CHECK_OUT_STEPS from './sharebox';
import PARTTEAM_KIOSK_CHECK_OUT_STEPS from './partteam';

export default {
  [KioskType.PARTTEAM]: PARTTEAM_KIOSK_CHECK_OUT_STEPS,
  [KioskType.SHAREBOX]: SHAREBOX_KIOSK_CHECK_OUT_STEPS,
};
